"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isBrowserMatched = exports.getBrowserVersionFromUserAgent = exports.getBrowserName = exports.checkSearchBotForAB = exports.checkBrowserSupportForWebChat = exports.webChatSupportedBrowsers = void 0;
// eslint-disable-next-line import/no-extraneous-dependencies
const browserslist_1 = __importDefault(require("browserslist"));
const ua_parser_js_1 = __importDefault(require("ua-parser-js"));
const web_env_1 = require("@snapchat/web-env");
// This file is derived from
// https://github.sc-corp.net/Snapchat/snapchat-web/blob/main/src/ui/session/UnsupportedBrowser/unsupportedBrowserCheck.ts
// It contains helper functions to determine which browser supports web chat
// This is to exclude users with certain browsers from AB related to web chat
// Refer to https://github.sc-corp.net/Snapchat/snapchat-web/blob/main/webpack.config.babel.ts#L176
exports.webChatSupportedBrowsers = (0, browserslist_1.default)(["Chrome >= 97", "Edge >= 97", "Safari >= 16"]);
var BrowserName;
(function (BrowserName) {
    BrowserName["SAFARI"] = "safari";
    BrowserName["CHROME"] = "chrome";
    BrowserName["IPAD"] = "ipados_saf";
    BrowserName["UNKNOWN"] = "unknown";
})(BrowserName || (BrowserName = {}));
/**
 * Checks if the current user's browser is supported for web chat
 */
function checkBrowserSupportForWebChat() {
    if (typeof (0, web_env_1.getNavigator)() !== "undefined" && (0, web_env_1.getNavigator)()?.userAgent) {
        // eslint-disable-next-line no-restricted-globals
        return isBrowserMatched(exports.webChatSupportedBrowsers, navigator.userAgent);
    }
    return {
        supported: false,
    };
}
exports.checkBrowserSupportForWebChat = checkBrowserSupportForWebChat;
/**
 * Checks if the user agent indicates search bot
 */
function checkSearchBotForAB() {
    if (typeof (0, web_env_1.getNavigator)() !== "undefined" && (0, web_env_1.getNavigator)()?.userAgent) {
        // eslint-disable-next-line no-restricted-globals
        return isBrowserMatched(exports.webChatSupportedBrowsers, navigator.userAgent, false);
    }
    return {
        supported: false,
    };
}
exports.checkSearchBotForAB = checkSearchBotForAB;
/**
 * Takes the user agent parsed object and returns us a browser name
 *
 * Derived from: https://github.com/fastmonkeys/is-browser-supported/blob/61d0ba3122472c00850255c8cc013bbffe41634f/index.js#L4
 * Also: https://github.com/DestinyItemManager/DIM/blob/3027459a4ba29bac083cc08a720b10f1fa476774/src/browsercheck.js#L7
 * Exported for testing.
 */
function getBrowserName(userAgent) {
    if (userAgent.ua.match(/bing|Bing|yahoo|Yahoo|google|Google/i) &&
        userAgent.ua.match(/bot|search|Search/i)) {
        return "search_bot";
    }
    if (userAgent.browser.name === "Chrome" && userAgent.os.name === "Android") {
        return "and_chr";
    }
    else if (userAgent.browser.name === "Firefox" && userAgent.os.name === "Android") {
        return "and_ff";
    }
    else if (userAgent.browser.name === "Chrome" && userAgent.ua.includes("CriOS")) {
        // when chrome on iphone/ipad requets desktop site, it's recognized as chrome on Mac OS.
        // Chrome has a `CriOS` in user agent to indicate it's on mobile.
        return "ios_chr";
    }
    else if (userAgent.browser.name === "Chrome" && userAgent.os.name === "iOS") {
        return "ios_chr";
    }
    else if ((userAgent.browser.name === "Mobile Safari" || userAgent.browser.name === "Safari") &&
        userAgent.device.type === "tablet") {
        // Let's exclude Ipad as web chat is conditionally supported
        // Refer to https://github.sc-corp.net/Snapchat/snapchat-web/blob/main/src/ui/session/UnsupportedBrowser/unsupportedBrowserCheck.ts#L170
        return BrowserName.IPAD;
    }
    else if (userAgent.browser.name === "Mobile Safari" ||
        (userAgent.browser.name === "Safari" && userAgent.os.name === "iOS")) {
        return "ios_saf";
    }
    else if (userAgent.browser.name === "Chromium" || userAgent.browser.name === "Brave") {
        // Related to Brave: ua-parser-js has gotten too smart since v1.0.34, and now resolves Brave to its own
        // browser name, even though the browser is Chromium-based. This is done by looking at `navigator` flags.
        // https://github.com/faisalman/ua-parser-js/blob/1e80cf3533559796e115d15875a0613fe619eb47/src/ua-parser.js#L939
        // Our browserlist doesn't include chrome, and the maintainers don't want it to.
        // https://github.com/browserslist/browserslist/issues/578
        // For the purposes of determining supported browsers, alias Brave to chrome.
        return "chrome";
    }
    else if (userAgent.browser.name === "Opera") {
        return "opera";
    }
    return userAgent.browser.name ?? "";
}
exports.getBrowserName = getBrowserName;
/**
 * Gets the browser name from getBrowserName function, however this caches the result.
 * The only time we perform another cache is when there is a change of userAgent string.
 */
const getBrowserNameCached = (() => {
    let browserNameCached;
    let lastUserAgent;
    return () => {
        if (!browserNameCached || (lastUserAgent && lastUserAgent !== (0, web_env_1.getNavigator)()?.userAgent)) {
            browserNameCached = getBrowserName((0, ua_parser_js_1.default)((0, web_env_1.getNavigator)()?.userAgent)).toLowerCase();
            lastUserAgent = (0, web_env_1.getNavigator)()?.userAgent;
        }
        return browserNameCached;
    };
})();
/**
 * Function that takes the user agent parsed result and returns a string representing the browser name and version.
 * The format of the string is as follows: "browser_name version"
 */
function getBrowserVersionFromUserAgent(userAgent) {
    const browserName = getBrowserNameCached();
    if (browserName === "search_bot") {
        return browserName;
    }
    const versionString = browserName === "ios_saf"
        ? userAgent.os.version
        : userAgent.browser.version || userAgent.os.version || "";
    const version = versionString ? versionString.split(".") : [];
    while (version.length > 0) {
        try {
            return browserName + " " + version.join(".");
        }
        catch (e) {
            // Ignore unknown browser query error
        }
        /* istanbul ignore next: difficult to test this */
        version.pop();
    }
    return undefined;
}
exports.getBrowserVersionFromUserAgent = getBrowserVersionFromUserAgent;
/**
 * Given an array of supported browsers and a user agent string checks to see if the user's browser is supported
 */
function isBrowserMatched(supportedBrowsers, userAgent, isBotSupported) {
    const agent = (0, ua_parser_js_1.default)(userAgent);
    const minBrowserVersions = new Map();
    for (const browser of supportedBrowsers) {
        const supportedBrowserVersion = browser.split(/[- ]/);
        minBrowserVersions.set(supportedBrowserVersion[0], Math.min(minBrowserVersions.get(supportedBrowserVersion[0]) || 999999, parseFloat(supportedBrowserVersion[1])));
    }
    const browser = getBrowserVersionFromUserAgent(agent);
    if (!browser) {
        return {
            supported: false,
        };
    }
    if (browser === "search_bot") {
        return {
            supported: isBotSupported ?? true,
            name: "bot",
        };
    }
    const browserNameAndVersion = browser.split(" ");
    const browserName = browserNameAndVersion[0];
    const browserVersion = browserNameAndVersion[1];
    const browserMinVersion = minBrowserVersions.get(browserName);
    const browserCheckResult = {
        supported: false,
        name: browserName,
        version: browserVersion,
    };
    if (browserMinVersion && browserMinVersion <= parseFloat(browserVersion)) {
        browserCheckResult.supported = true;
    }
    return browserCheckResult;
}
exports.isBrowserMatched = isBrowserMatched;
//# sourceMappingURL=webchatBrowserSupportUtil.js.map